import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { getErrors } from '@/auth/store/selectors'

/**
 * Auth's helper hook that takes care of the submit errors
 * Errors are assigned to a specific form's fields or as form's generic errors
 *
 * @param {function} setError - setError function returned by react-hook-form on
 *   form initialization
 * @return {object}
 *   formSubmitMessages - form's generic errors returned by server
 *   resetErrors - function to reset form's generic errors
 */
const useErrors = (setError) => {
  const { $messages: formSubmitMessages = [], ...formSubmitErrors } = useSelector(getErrors)
  const [formSubmitErrorsRendered, setFormSubmitErrorsRendered] = useState(false)

  const resetErrors = useCallback(() => {
    setFormSubmitErrorsRendered(false)
  }, [])

  useEffect(() => {
    if (formSubmitErrorsRendered) {
      return
    }
    for (const [field, errors] of Object.entries(formSubmitErrors)) {
      setError(field, {
        type: 'server',
        message: errors.toString()
      })
    }
    if (Object.keys(formSubmitErrors).length > 0) {
      setFormSubmitErrorsRendered(true)
    }
  }, [formSubmitErrors, setError, formSubmitErrorsRendered, setFormSubmitErrorsRendered])

  return { formSubmitMessages, resetErrors }
}

export default useErrors
